const defaultState = {
  isAddNew: '',  // control based on score is NULL or not
  score: {
    gc: '',
    id: '',
    si: '',
    dt_g: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    dt_b: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  school_dt: {
    res: -1,      // control 0 is not found or invalid school code
    scod: '',
    schENG: '',
    schKH: '',
    proENG: '',
    proKH: '',
    disENG: '',
    disKH: '',
    comENG: '',
    comKH: '',
    fid: '',      // forign key ID
    type_code: '',
    g7: '',
    g8: '',
    g9: '',
    g10: '',
    g11: '',
    g18: '',
    g12: '',
    g19: '',
    pho_num: '',  // telephone number
    sco_g7: [], // if score is NULL-->insert data else -->Update data
    sco_g8: [],
    sco_g9: [],
    sco_g10: [],
    sco_g11: [],
    sco_g18: [],
    sco_g12: [],
    sco_g19: []
  }
}

export default defaultState
